import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderAnimationComponent, LoadingSpinnerComponent, RequestLoaderComponent } from './components';
import { BorderSpinnerComponent } from './components/border-spinner/border-spinner.component';
import { GravatarComponent } from '@shared/gravatar/gravatar.component';

@NgModule({
  declarations: [RequestLoaderComponent, LoaderAnimationComponent, LoadingSpinnerComponent, BorderSpinnerComponent, GravatarComponent],
  imports: [CommonModule],
  exports: [RequestLoaderComponent, LoadingSpinnerComponent, BorderSpinnerComponent, GravatarComponent],
})
export class RequestLoaderModule {}
